import { render, staticRenderFns } from "./PosCartItem.vue?vue&type=template&id=1056d2f4&scoped=true"
import script from "./PosCartItem.vue?vue&type=script&lang=js"
export * from "./PosCartItem.vue?vue&type=script&lang=js"
import style0 from "./PosCartItem.vue?vue&type=style&index=0&id=1056d2f4&prod&lang=scss&scoped=true"
import style1 from "./PosCartItem.vue?vue&type=style&index=1&id=1056d2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056d2f4",
  null
  
)

export default component.exports